import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionGroupConfig from 'modules/surveys/store/models/QuestionGroupConfig'

class QuestionGroupConfigs extends Collection<QuestionGroupConfig> {
  get cacheKey(): string {
    return 'surveysQuestionGroupConfigs'
  }
  model() {
    return QuestionGroupConfig
  }
}

export default new QuestionGroupConfigs()
